import { render, staticRenderFns } from "./TermsLGPD.vue?vue&type=template&id=7589dc45&scoped=true&"
import script from "./TermsLGPD.vue?vue&type=script&lang=js&"
export * from "./TermsLGPD.vue?vue&type=script&lang=js&"
import style0 from "./TermsLGPD.vue?vue&type=style&index=0&id=7589dc45&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7589dc45",
  null
  
)

export default component.exports